import { useMutation, useQueryClient } from '@tanstack/react-query';
import MessageTemplateService, {
  ICreateMessageTemplateParams,
} from '@clickersphere/core/services/MessageTemplateService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import {
  MessageTemplateQueryData,
  MESSAGE_TEMPLATES_QUERY_KEY,
} from './useMessageTemplates';

export function useCreateMessageTemplate() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    isPending: createMessageTemplateIsPending,
    mutateAsync: createMessageTemplateAsync,
  } = useMutation({
    mutationFn: async (data: ICreateMessageTemplateParams) => {
      const template = await MessageTemplateService.create(data);
      return template as MessageTemplateQueryData;
    },
    onSuccess: async (data) => {
      await queryClient.cancelQueries({
        queryKey: buildQueryKey(MESSAGE_TEMPLATES_QUERY_KEY),
      });

      queryClient.setQueryData<MessageTemplateQueryData[]>(
        buildQueryKey(MESSAGE_TEMPLATES_QUERY_KEY),
        (old) => [...(old ?? []), data],
      );
    },
  });

  return {
    createMessageTemplateAsync,
    createMessageTemplateIsPending,
  };
}
